export default {"src":"/_next/static/media/rainbow-purple-to-blue-left.1808a849.svg","height":220,"width":1920,"blurWidth":0,"blurHeight":0};